import RestError from '../../modules/app/errors';

export const REASON_PIN_INVALID = 'PIN_INVALID';
export const REASON_PIN_BLOCKED = 'PIN_BLOCKED';
export const REASON_TOO_MANY_METHODS = 'TOO_MANY_PAYMENT_METHODS';

export class TransferBadRequestError extends RestError {
}

export class TransferForbiddenError extends RestError {
}
